import { deriveSendFn, deriveRestoreFn } from '@cian/core/threads/index.js';

const NAMESPACE = 'config.comparator';
/**
 * Две настройки считаются равными, если у них одинаковый приоритет {@link ISetting.priority}.
 *
 * @export
 * @param {ISetting} a
 * @param {ISetting} b
 * @return {boolean}
 */
const priorityComparator = sendableComparator((a, b) => {
    return a.priority === b.priority;
}, NAMESPACE + '.priorityComparator');
/**
 * Создает композицию компараторов {@link SettingComparator}, которая возвращает `true`, если все
 * компараторы в композиции возвращают `true`.
 *
 * @export
 * @param {Iterable<SettingComparator>} comparators
 * @return {SettingComparator}
 */
function comparatorCompose(comparators) {
    const composer = (a, b) => {
        for (const comparator of comparators) {
            if (!comparator(a, b)) {
                return false;
            }
        }
        return true;
    };
    return composer;
}
/**
 * Создает из функции компаратора разделяемый между потоками объект
 *
 * @export
 * @template F - тип компаратора
 * @param {F} comparator - компаратор
 * @param {string} name - имя для реестра премещаемых объектов
 * @return {SendableComparator<F>}
 */
function sendableComparator(comparator, name) {
    const sendable = deriveSendFn(comparator, name).unwrap();
    sendable.restore = deriveRestoreFn(sendable);
    return sendable;
}

export { comparatorCompose, priorityComparator, sendableComparator };
//# sourceMappingURL=comparator.js.map
